import React from 'react';

import SiteLayout from 'Config/SiteLayout';

export default class AuthLayout extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const Component = SiteLayout.site_layout_files.auth_layout;
        
        return (<Component {...this.props} />);
    };
}
